import Navbar from "./components/Navbar";

import Hero from "./components/Hero";
import About from "./components/About";
import Results from "./components/Results";
import Target from "./components/Target";
import CTA from "./components/CTA";
import Footer from "./components/Footer"; // 👈 IMPORTANTE

import "./styles/main.css";

export default function Landing() {
  return (
    <div>

      {/* 🔝 NAVBAR GLOBAL */}
      <Navbar />

      {/* 🌐 SECCIONES */}
      <Hero />
      <About />
      <Results />
      <Target />
      <CTA />

      {/* 🔻 FOOTER */}
      <Footer />

    </div>
  );
}